export const CODE_SUCCESS = 'api.success';

// 需要和 cc-next-weh 保持一致
export const SESSION_KEY = 'ccodv3';
export const SESSION_KEY_CLIENT = 'ccodv3_client';
